// components/NoDataAvailable.jsx
import React from 'react';
import noDataImg from "../assets/images/no-data.svg";

const NoRecordsFound = () => {
  return (
    <div style={{
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
      overflow: "hidden",
      textAlign: "center",
      padding: "16px",
    }}>
      <img 
        src={noDataImg}
        alt="No records found"
        style={{ 
          width: '60px', 
          height: '60px', 
          marginBottom: '16px',
          opacity: 0.7
        }}
      />
      <p style={{ color: '#666', margin: 0 }}>
        No records found
      </p>
    </div>
  );
};

export default NoRecordsFound;
